<div class="avatar avatar-{{size}}" *ngIf="user?.Image && !imageError">
  <img 
    srcset="{{ user.Image | imageSize : imageSizes[size] * 2 : imageSizes[size] * 2 }} 2x {{ user.Image | imageSize : imageSizes[size] * 3 : imageSizes[size] * 3 }} 3x"
    [src]="user.Image | imageSize : imageSizes[size] : imageSizes[size]" 
    class="avatar-img rounded-circle" [alt]="tooltip()" (error)="imageError = true;">
</div>

<div class="avatar avatar-{{size}}" *ngIf="!user?.Image || imageError">
  <span class="avatar-title rounded-circle" [style.background-color]="getColor().bgColor">{{ getInitials() }}</span>
</div>